import { useEffect } from "react";
import Navbar from "./Navbar";
import { ArrowRight } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function HeroSection() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <section className="relative overflow-hidden min-h-[95vh] text-white">

      {/* Background */}
      <div className="absolute inset-0 scale-105 animate-[slowZoom_30s_linear_infinite]">
        <img
          src="https://images.unsplash.com/photo-1500382017468-9049fed747ef"
          alt="Regenerative agriculture"
          className="w-full h-full object-cover"
        />

        {/* STRONGER readability overlay */}
        <div
          className="absolute inset-0 bg-gradient-to-br 
          from-black/65 
          via-black/45 
          to-black/70"
        />
      </div>

      {/* Navbar */}
      <div data-aos="fade-down" className="relative z-20">
        <Navbar />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 pt-32 lg:pt-40 pb-24">

        {/* Optional subtle readability panel */}
        <div className=" px-0 lg:px-6 py-10 rounded-2xl max-w-6xl">

          <h1
            data-aos="fade-up"
            className="text-3xl md:text-6xl lg:text-7xl  leading-[1.08] tracking-tight mt-10 lg:mt-16"
            style={{ textShadow: "0 2px 18px rgba(0,0,0,0.45)" }}
          >
            Climate Action That Delivers Real Community Impact{" "}
            <span className="block italic font-light text-green-400 mt-4">
              Invest in Climate-Smart Solutions That Strengthen Livelihoods and Restore Futures
            </span>
          </h1>

          <p
            data-aos="fade-up"
            data-aos-delay="200"
            className="mt-6 text-white/90 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light"
            style={{ textShadow: "0 2px 12px rgba(0,0,0,0.35)" }}
          >
            The ANNA OKWARA Foundation works directly with women, youth, and farmers to deliver practical climate solutions that improve food security, create livelihoods, and build long-term resilience. Every contribution is converted into measurable, field-level impact.
          </p>

          {/* CTA */}
          <div
            data-aos="zoom-in"
            data-aos-delay="400"
            className="flex justify-center mt-10 sm:mt-14"
          >
            <a
              href="https://www.linkedin.com/company/anna-foundations/"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-green-600 hover:bg-white hover:text-black transition-all duration-300 text-black px-8 py-4 rounded-full flex items-center gap-3 tracking-wide w-fit shadow-lg"
            >
              Sponsor a Project

              <span className="group-hover:translate-x-1 transition-transform duration-300">
                <ArrowRight size={18} />
              </span>
            </a>
          </div>

        </div>
      </div>

      {/* Glow effects */}
      <div className="absolute -top-32 -left-32 w-[300px] h-[300px] bg-[#22C55E] opacity-10 blur-[120px]" />
      <div className="absolute bottom-0 right-0 w-[300px] h-[300px] bg-[#22C55E] opacity-10 blur-[120px]" />

      <style jsx>{`
        @keyframes slowZoom {
          0% { transform: scale(1.05); }
          50% { transform: scale(1.12); }
          100% { transform: scale(1.05); }
        }
      `}</style>
    </section>
  );
}